import { render } from "./ResultCard.vue?vue&type=template&id=3fb6bb01&scoped=true&ts=true"
import script from "./ResultCard.vue?vue&type=script&lang=ts"
export * from "./ResultCard.vue?vue&type=script&lang=ts"

import "./ResultCard.vue?vue&type=style&index=0&id=3fb6bb01&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb6bb01"]])

export default __exports__